<div *ngIf="status"
  class="px-3 rounded-pill mat-caption text-center"
  [ngStyle]="{'color': statusColor.text || 'black' ,'background-color': statusColor.background || 'lightgrey'}">
  {{'ORDER_PAYMENT.LABEL.' + status.toUpperCase() | translate}}
</div>